<app-grid
  gridCssClass="tab-grid-no-summary"
  stateKey="RoleMenuItems"
  [columnDefs]="columnDefs"
  [rowData]="rowData$ | async"
  [showDelete]="false"
  [pagination]="false"
  (rowSelected)="rowSelected($event)"
  (save)="save()"
>
</app-grid>
